export function emailSignup($this) {
    var emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    var $this = $this;
    var $container = $this.closest('.newsletter-signup-inline');
    var $newsletterForm = $container.find('form');
    var $email = $newsletterForm.find(".newsletter-email");
    var email = $newsletterForm.find(".newsletter-email").val();
    var $error = $container.find('.newsletter-form-error');
    var $defaultColor = $email.css('color');

    $email.css('border', '').css('color', $defaultColor);
    $email.on('keydown', function () {
        $email.css('border', '').css('color', $defaultColor);
    });

    let segment = 'CF-Outfitters-Footer';
    let event = 'CF-Outfitters-Footer-Signup';
    let list = 'Microsite';

    if ($this.closest(".email-blog-widget").length) {
        segment = 'CF-Outfitters-Blog';
        event = 'CF-Outfitters-Footer-Signup';
    } else if ($this.closest(".sidebar-email").length) {
        segment = 'CF-Outfitters-Sidebar';
        event = 'CF-Outfitters-Footer-Signup';
    }

    if (email.search(emailRegEx) == -1) {
        $newsletterForm.fadeOut('fast', function () {
            $error.fadeIn(800, function () {
                $error.fadeOut(800, function () {
                    $email.css('border', '1px solid red').css('color', 'red');
                    $newsletterForm.fadeIn('fast');
                });
            });
        });
        $this.removeAttr("disabled");
        return false;
    } else {
        jQuery.post('/subscribe.php', {
            'email': email,
            'segment': segment,
            'event': event,
            'list': list
        },
        function (data) {
            jQuery(".rightCol").hide();
            jQuery(".newsletter-form-container").attr('style', 'display:none !important');
            jQuery(".thankyouemail").show();
        });

        if (typeof gtag !== "undefined") {
            if ($this.closest("#email-signup-top").length) {
                gtag("event", "email_signup", { "content_group": "Hero" });
            } else if ($this.closest("#footer").length) {
                gtag("event", "email_signup", { "content_group": "Footer" });
            } else if ($this.closest(".sidebar-email").length) {
                gtag("event", "email_signup", { "content_group": "Sidebar" });
            }
        }
    }
}